import { ingredientService } from "../../../services/ingredients.service";


export async function addProductLoader() {
    const urlParams = new URLSearchParams(document.location.search);
    return { ingredients: await ingredientService.get(urlParams.has('refresh')) }
}